import { createReducer, on } from '@ngrx/store';
import { initialStateCompany } from './company.types';
import {
  setCityId,
  setCompany,
  setCompanyContainsCorbanDebt,
  setCompanyIcon,
  setCompanyIdentity,
  setCompanyLogo,
  setCompanyName,
  setCompanyRecommendationWhenStartingInstallment,
  setDebtsSource,
  setExtractDebts,
  setInstallation,
  setPrincipalType,
  setShowReferenceDate,
  setShowSelfFees,
} from './company.actions';
import { produce } from 'immer';
import { PrincipalTypes } from 'src/app/models/filter-companies';

export const companyReducer = createReducer(
  initialStateCompany,

  on(setCompany, (state, { company }) =>
    produce(state, (draft) => {
      Object.assign(draft, company);
    })
  ),

  on(setCompanyName, (state, { companyName }) =>
    produce(state, (draft) => {
      draft.companyName = companyName;
    })
  ),

  on(setCompanyLogo, (state, { companyLogo }) =>
    produce(state, (draft) => {
      draft.companyLogo = companyLogo;
    })
  ),

  on(setCompanyIcon, (state, { companyIcon }) =>
    produce(state, (draft) => {
      draft.companyIcon = companyIcon;
    })
  ),

  on(setInstallation, (state, { installation }) =>
    produce(state, (draft) => {
      draft.installation = installation;
    })
  ),

  on(setExtractDebts, (state, { isExtractDebts }) =>
    produce(state, (draft) => {
      draft.isExtractDebts = isExtractDebts;
    })
  ),

  on(setShowReferenceDate, (state, { showReferenceDate }) =>
    produce(state, (draft) => {
      draft.showReferenceDate = showReferenceDate;
    })
  ),

  on(setShowSelfFees, (state, { showSelfFees }) =>
    produce(state, (draft) => {
      draft.showSelfFees = showSelfFees;
    })
  ),

  on(setDebtsSource, (state, { debtSource }) =>
    produce(state, (draft) => {
      draft.debtSource = debtSource;
    })
  ),

  on(setCityId, (state, { cityId }) =>
    produce(state, (draft) => {
      draft.cityId = cityId;
    })
  ),

  on(setPrincipalType, (state, { principalType }) =>
    produce(state, (draft) => {
      draft.principalType = principalType as PrincipalTypes;
    })
  ),

  on(setCompanyIdentity, (state, { companyIdentity }) =>
    produce(state, (draft) => {
      draft.companyIdentity = companyIdentity;
    })
  ),

  on(setCompanyContainsCorbanDebt, (state, { containsCorbanDebt }) =>
    produce(state, (draft) => {
      draft.containsCorbanDebt = containsCorbanDebt;
    })
  ),

  on(
    setCompanyRecommendationWhenStartingInstallment,
    (state, { recommendationWhenStartingInstallment }) =>
      produce(state, (draft) => {
        draft.recommendationWhenStartingInstallment = recommendationWhenStartingInstallment;
      })
  )
);
